export default {
  valueType: "@group",
  FormItemProps: {
    grid: 2,
    style: {
      marginBottom: "20px",
      width: "100%",
      minWidth: "900px"
    }
  },
  HeaderProps: {
    style: {}
  },
  ControlProps: {
    Content: [],
    style: {
      padding: "10px 20px"
    },
  },
}